import { useState } from "react";
import { Menu, CalendarDays, ClipboardCheck, HandCoins, Phone } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { LogoBadge } from "./kit";

const LINKS = [
  ["#schedule", "Schedule"],
  ["#highlights", "Highlights"],
  ["#location", "Location"],
  ["#gallery", "Gallery"],
  ["#register", "Register & Support", "join"],
  ["#contact", "Contact"],
];

const BOTTOM = [
  ["#schedule", "Schedule", CalendarDays],
  ["#register", "Join", ClipboardCheck],
  ["#support", "Donate", HandCoins],
  ["#contact", "Contact", Phone],
];

export const Nav = ({ content }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <header className="sticky top-0 z-40 border-b border-neutral-900 bg-neutral-950/90 backdrop-blur-md" data-testid="site-header">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5">
          <a href="#top" className="flex min-w-0 items-center gap-2.5" data-testid="nav-brand">
            <LogoBadge content={content} className="h-10 w-[60px] rounded-lg p-0.5" testid="nav-logo" />
            <span className="font-display text-xl font-bold text-gold">{content.event_title}</span>
            <span className="hidden font-script text-base text-red-500 min-[400px]:inline">Festival</span>
          </a>
          <nav className="hidden items-center gap-6 lg:flex">
            {LINKS.map(([href, label, slug]) => (
              <a key={href} href={href} data-testid={`nav-link-${slug || label.toLowerCase()}`} className="text-sm font-medium text-neutral-400 transition-colors hover:text-amber-400">
                {label}
              </a>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            <a href="#register" data-testid="nav-register-cta" className="rounded-full bg-amber-500 px-4 py-2 font-display text-sm font-semibold text-neutral-950 transition-colors hover:bg-amber-400">
              Register
            </a>
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild>
                <button aria-label="Open menu" data-testid="nav-menu-button" className="rounded-md p-2 text-neutral-300 hover:bg-neutral-900 lg:hidden">
                  <Menu className="h-6 w-6" />
                </button>
              </SheetTrigger>
              <SheetContent side="right" className="w-72 border-neutral-800 bg-neutral-950 p-0">
                <SheetTitle className="sr-only">Menu</SheetTitle>
                <div className="kente kente-thin" />
                <div className="flex flex-col p-6 pt-10">
                  {LINKS.map(([href, label, slug], i) => (
                    <a
                      key={href}
                      href={href}
                      onClick={() => setOpen(false)}
                      data-testid={`mobile-nav-link-${slug || label.toLowerCase()}`}
                      className="rise border-b border-neutral-900 py-4 font-display text-2xl text-neutral-200 transition-colors hover:text-amber-400"
                      style={{ animationDelay: `${i * 40}ms` }}
                    >
                      {label}
                    </a>
                  ))}
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </header>
      <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-neutral-800 bg-neutral-950/95 backdrop-blur-md lg:hidden" data-testid="mobile-bottom-nav">
        <div className="grid grid-cols-4">
          {BOTTOM.map(([href, label, Icon]) => (
            <a key={href} href={href} data-testid={`bottom-nav-${label.toLowerCase()}`} className="flex flex-col items-center gap-1 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-neutral-400 transition-colors active:text-amber-400">
              <Icon className="h-5 w-5" />
              {label}
            </a>
          ))}
        </div>
      </nav>
    </>
  );
};
